/**
 * ЗВУК ВХОДЯЩЕГО — КОРОТКИЙ ДВОЙНОЙ ТОН, БЕЗ ФАЙЛА (`s720`). Играет одна вкладка на весь браузер
 * (ведущая, `vkladki.ts`). Браузер не даёт звук вкладке, в которой человек ещё ничего не нажимал, —
 * тогда звука просто нет: уведомление от этого не ломается и фокус ни у кого не отбирается.
 */
let kontekst: AudioContext | null = null;

export function sygratVhodyashchee(): void {
  try {
    const Konstruktor = window.AudioContext ?? (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
    if (Konstruktor === undefined) return;
    kontekst ??= new Konstruktor();
    if (kontekst.state === 'suspended') void kontekst.resume().catch(() => {});
    if (kontekst.state !== 'running') return;

    const nachalo = kontekst.currentTime;
    for (const [sdvig, chastota] of [[0, 880], [0.16, 1175]] as const) {
      const ton = kontekst.createOscillator();
      const gromkost = kontekst.createGain();
      ton.type = 'sine';
      ton.frequency.value = chastota;
      gromkost.gain.setValueAtTime(0.0001, nachalo + sdvig);
      gromkost.gain.exponentialRampToValueAtTime(0.18, nachalo + sdvig + 0.02);
      gromkost.gain.exponentialRampToValueAtTime(0.0001, nachalo + sdvig + 0.14);
      ton.connect(gromkost).connect(kontekst.destination);
      ton.start(nachalo + sdvig);
      ton.stop(nachalo + sdvig + 0.15);
    }
  } catch {
    // Звук не обязателен: молча обходимся без него.
  }
}
